import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function DemoBanner({ variant = "full" }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [timeLeft, setTimeLeft] = useState(null);
    const [expired, setExpired] = useState(false);

    const isPOS = location.pathname === "/admin/pos";
    const expiresAt = sessionStorage.getItem("demo_expires_at");
    const isDemo = sessionStorage.getItem("demo_mode") === "true" || !!expiresAt;

    useEffect(() => {
        if (!expiresAt) return;

        const tick = () => {
            const diff = Math.floor((new Date(expiresAt) - Date.now()) / 1000);
            if (diff <= 0) {
                setExpired(true);
                sessionStorage.removeItem("demo_expires_at");
                sessionStorage.removeItem("demo_mode");
                setTimeout(() => {
                    window.location.href = "/#precios";
                }, 2000);
            } else {
                setTimeLeft(diff);
            }
        };

        tick();
        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [expiresAt]);

    if (!isDemo) return null;

    // Si estamos en POS y el componente es el "Global" (full), no lo mostramos 
    // porque el POS renderizará su propia versión mini.
    if (isPOS && variant === "full") return null;

    const formatTime = (s) => {
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return `${m}:${String(sec).padStart(2, "0")}`;
    };

    if (expired) {
        return (
            <div style={variant === "mini" ? s.miniExpired : s.bannerExpired}>
                <span>⏱ Sesión demo expirada</span>
                {variant === "full" && (
                    <button id="demo-expired-btn" style={s.ctaBtn} onClick={() => (window.location.href = "/#precios")}>
                        Ver planes →
                    </button>
                )}
            </div>
        );
    }

    if (variant === "mini") {
        return (
            <div style={s.mini}>
                <div style={s.miniLeft}>
                    <span style={s.miniPill}>MODO DEMO ACTIVO</span>
                    {timeLeft !== null && (
                        <span style={s.miniTimer}>⏱ {formatTime(timeLeft)}</span>
                    )}
                </div>
                <button
                    style={s.miniBtn}
                    onClick={() => navigate("/onboarding")}
                    title="Convertir a Restaurante Real"
                >
                    🚀 FINALIZAR DEMO
                </button>
            </div>
        );
    }

    return (
        <div style={s.banner}>
            <div style={s.left}>
                <span style={s.pill}>DEMO</span>
                <span style={s.text}>Estás en modo demo · Funciones de impresión desactivadas</span>
                {timeLeft !== null && (
                    <span style={s.timer} title="Tiempo restante de sesión">
                        ⏱ {formatTime(timeLeft)}
                    </span>
                )}
            </div>
            <div style={s.right}>
                <span style={s.subtle}>¿Te convence?</span>
                <button id="demo-cta-btn" style={s.ctaBtn} onClick={() => navigate("/onboarding")}>
                    Crear mi restaurante →
                </button>
            </div>
        </div>
    );
}

const s = {
    banner: {
        position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9000,
        background: "#0B3C5D", borderTop: "1px solid rgba(255,255,255,0.15)",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0.625rem 1.5rem", gap: "1rem",
        fontFamily: "'Inter', system-ui, sans-serif",
    },
    bannerExpired: {
        position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9000,
        background: "#7f1d1d", borderTop: "1px solid rgba(255,0,0,0.3)",
        display: "flex", alignItems: "center", justifyContent: "center",
        gap: "1.5rem", padding: "0.75rem 1.5rem", color: "#fca5a5",
        fontFamily: "'Inter', system-ui, sans-serif", fontSize: "0.9rem",
    },
    mini: {
        background: "#1e1b4b", border: "1px solid #4338ca",
        borderRadius: "0.75rem", padding: "0.75rem", marginBottom: "0.5rem",
        display: "flex", flexDirection: "column", gap: "0.5rem",
        fontFamily: "'Inter', system-ui, sans-serif",
    },
    miniExpired: {
        background: "#450a0a", border: "1px solid #991b1b",
        borderRadius: "0.75rem", padding: "0.75rem", color: "#fca5a5", fontSize: "0.75rem",
    },
    miniLeft: { display: "flex", alignItems: "center", justifyContent: "space-between" },
    miniPill: {
        color: "#818cf8", fontSize: "0.6rem", fontWeight: "900", letterSpacing: "0.05em",
    },
    miniTimer: { color: "#fff", fontSize: "0.75rem", fontWeight: "700", fontFamily: "monospace" },
    miniBtn: {
        background: "#EAB308", border: "none", borderRadius: "0.4rem",
        padding: "0.4rem 0.75rem", color: "#000", fontWeight: "800",
        fontSize: "0.7rem", cursor: "pointer", width: "100%",
    },
    left: { display: "flex", alignItems: "center", gap: "0.75rem" },
    right: { display: "flex", alignItems: "center", gap: "0.875rem", flexShrink: 0 },
    pill: {
        background: "rgba(255,255,255,0.2)", color: "#fff",
        fontSize: "0.65rem", fontWeight: "800", letterSpacing: "0.1em",
        padding: "0.2rem 0.5rem", borderRadius: "4px",
    },
    text: { color: "#bfdbfe", fontSize: "0.82rem" },
    timer: { color: "#93c5fd", fontSize: "0.82rem", fontFamily: "monospace" },
    subtle: { color: "#93c5fd", fontSize: "0.8rem" },
    ctaBtn: {
        background: "#EAB308", border: "none", borderRadius: "0.5rem",
        padding: "0.5rem 1.125rem", color: "#000", fontWeight: "700",
        fontSize: "0.85rem", cursor: "pointer", fontFamily: "inherit",
        whiteSpace: "nowrap",
    },
};
